import { useSetStudioCoversSwitch, useStudioCoversSwitch } from '@/api/endpoints/settings'
import { Toggle } from '@/components/ui/Toggle'
import { errorMessage } from '@/lib/errors'
import { formatRelativeDate } from '@/lib/format'
import styles from './StudioCoversSwitch.module.scss'
import { QueryErrorNotice } from '@/components/feedback/QueryErrorNotice'

/**
 * "Automação de capas": desliga a drenagem de capas dos Shorts inteira, para
 * quando o celular sai do USB por um tempo. Desligada, nenhuma drenagem roda
 * (fim do ciclo de upload, editor de retenção, botão do Scheduler) e a faixa
 * "Capas dos Shorts" some do Scheduler. A fila continua enchendo e drena
 * quando religar. Só o admin vê a aba; a API responde 403 aos outros.
 */
export function StudioCoversSwitch() {
  const status = useStudioCoversSwitch()
  const update = useSetStudioCoversSwitch()
  const data = status.data
  const checked = update.isPending ? update.variables : (data?.enabled ?? false)

  return (
    <div className={styles.panel}>
      <Toggle
        id="studio-covers-switch"
        label="Automação de capas pelo celular"
        checked={checked}
        disabled={!data || update.isPending}
        onCheckedChange={(next) => {
          update.mutate(next)
        }}
      />
      {status.isError ? (
        <QueryErrorNotice
          compact
          error={status.error}
          label="o estado da automação"
          onRetry={() => {
            void status.refetch()
          }}
        />
      ) : null}
      {update.isError ? (
        <span className={styles.fail} role="alert">
          ⚠️ {errorMessage(update.error, 'Não foi possível salvar agora.')}
        </span>
      ) : null}
      {data && !data.server_enabled ? (
        <span className={styles.fail}>
          A capa pelo Studio está desligada neste servidor (<code>STUDIO_THUMBNAIL_ENABLED</code>): o
          interruptor não tem efeito aqui.
        </span>
      ) : null}
      {data && !data.enabled ? (
        <span className={styles.paused} role="status">
          Desligada{data.updated_at ? ` em ${formatRelativeDate(data.updated_at)}` : ''}.{' '}
          {data.pending > 0
            ? `${String(data.pending)} ${data.pending === 1 ? 'capa espera' : 'capas esperam'} na fila.`
            : 'Nenhuma capa na fila.'}
        </span>
      ) : null}
      <span className={styles.hint}>
        Desligada, nenhuma drenagem de capas roda — nem a do fim do ciclo de upload, nem a do editor
        de retenção, nem o botão do Scheduler — e a faixa "Capas dos Shorts" some do Scheduler. Use
        quando o celular sair do USB por um tempo. Os vídeos publicados continuam entrando na fila e
        recebem a capa quando religar, se ainda estiverem na janela de novas tentativas.
      </span>
    </div>
  )
}
